export const BUILD_INFO = {
  buildId: '180958',
  commit: '2cc2c27'
};
